
import React from 'react';
import L from 'leaflet';
import { connect } from 'react-redux';
import { RootState } from 'typesafe-actions';
import { Marker, Popup } from 'react-leaflet';
import oval from '../../assets/images/oval.svg';


const portIcon = new L.Icon({
  iconUrl: oval,
  iconSize: [150, 150]
});

export const ItineraryMarker: React.FC<ItineraryMarkerProps> = (
  {
    itinerary
  }
) => {

  if (!itinerary) {
    return <div></div>;
  }

  const markerProps = {
    zIndexOffset:220,
    icon:portIcon,
    riseOnHover:true,
  };

  const ItineraryMarker = itinerary.map(port =>{
    // const initMarker = (ref: any) => {
    //   if (ref) {
    //     ref.leafletElement.closePopup = (e: any)=>{ 
    //       togglePort(port);
    //     };
    //     ref.leafletElement.openPopup = (e: any)=>{ 
    //       togglePort(port);
    //     };
    //   }
    // };
    return (
      <div
        key={"itinerary" + port.id + 0}
      >
        <Marker
          {...markerProps}
          key={"port" + port.id + 1}
          position={[
            port.latitude,
            port.longitude
          ]}
          // ref= {initMarker}
          // onClick={ ()=> togglePort(port)}
        
        >
          <Popup tabIndex={-1} closeOnClick={false} autoClose={false} autoPan={false} closeButton={false}>
          </Popup>;
        </Marker>

        <Marker
          {...markerProps}
          key={"port" + port.id + 2}
          keyboard={false}
          position={[
            port.latitude,
            port.longitude - 360
          ]}
          // onClick={ ()=> togglePort(port)}


        />
      </div>);});

  return <div>{ItineraryMarker}</div>;


};

const mapStateToProps = (state: RootState) => ({
  itinerary: state.user.itinerary
});

const dispatchProps = {

};

type ItineraryMarkerProps = ReturnType<typeof mapStateToProps> & typeof dispatchProps;

export default connect(
  mapStateToProps,
  dispatchProps
)(ItineraryMarker);